export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-100/60 via-primary-50/40 to-accent-100/50 rounded-3xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/80 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-smartphone-line"></i>
              <span>移动端专属体验</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">移动端阅读</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md">
              为移动端深度优化的下拉式漫画阅读体验。支持手势滑动翻页、横屏全屏观看、无弹窗纯净阅读。
              无论通勤路上还是睡前时光，随时随地开启你的追漫之旅。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              {['下拉式流畅阅读', '横屏全屏观看', '手势翻页控制', '离线缓存支持'].map((f) => (
                <span key={f} className="text-xs font-medium text-foreground-600 bg-background-50 px-3 py-1.5 rounded-full border border-background-200 whitespace-nowrap">
                  {f}
                </span>
              ))}
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="relative w-[220px] h-[400px] md:w-[260px] md:h-[480px] rounded-3xl overflow-hidden bg-background-200 shadow-[0_8px_30px_rgba(0,0,0,0.08)]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20colorful%20manga%20page%20in%20vertical%20scroll%20reading%20mode%2C%20warm%20ambient%20lighting%2C%20clean%20minimal%20phone%20frame%2C%20manga%20art%20style%20visible%20on%20screen%20with%20vibrant%20warm%20colors%2C%20cozy%20reading%20atmosphere%2C%20soft%20shadows%2C%20editorial%20product%20photography%20style%2C%20isolated%20on%20soft%20cream%20background&width=520&height=960&seq=mobile-app-mockup&orientation=portrait"
                alt="爱漫画网移动端下拉式漫画阅读体验"
                title="爱漫画网移动端漫画阅读"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}